import { UserHelper } from '~modules/user/model';

import { useAuth } from './use-auth';

export function useIsAdmin() {
	const { user } = useAuth();
	if (!user) return false;
	return UserHelper.isAdmin(user);
}

export function useIsCustomer() {
	const { user } = useAuth();
	if (!user) return false;
	return UserHelper.isCustomer(user);
}

export function useIsManager() {
	const { user } = useAuth();
	if (!user) return false;
	return UserHelper.isManager(user);
}

export function useIsCabinet() {
	const { user } = useAuth();
	if (!user) return false;
	return UserHelper.isCabinet(user);
}

export function useIsNoGroups() {
	const { user } = useAuth();
	if (!user) return false;
	return UserHelper.isNoGroups(user);
}

export function useIsTabel() {
	const { user } = useAuth();
	if (!user) return false;
	return UserHelper.isTabel(user);
}

export function useIsHr() {
	const { user } = useAuth();
	if (!user) return false;
	return UserHelper.isHr(user);
}
